import { useEffect, useState } from "react";
import { apiFetchPublic } from "../lib/api";
import { photoUrl } from "../lib/assets";

export { photographyShowcaseHref } from "../lib/homeHeroPhotos";

/** @typedef {{ id: string, src: string, cap: string, description?: string, keywords?: string[], focusX?: number, focusY?: number }} HeroSlide */

/** @param {{ id: number | string, imageKey: string, url?: string, title?: string, description?: string, keywords?: string[], focusX?: number, focusY?: number }} photo */
function photoToSlide(photo) {
  return {
    id: String(photo.id),
    src: photoUrl(photo),
    cap: photo.title || "",
    description: photo.description || "",
    keywords: photo.keywords || [],
    focusX: typeof photo.focusX === "number" ? photo.focusX : 50,
    focusY: typeof photo.focusY === "number" ? photo.focusY : 50,
  };
}

/** @returns {{ slides: HeroSlide[], loading: boolean }} */
export function useHomeHeroSlides() {
  const [slides, setSlides] = useState(/** @type {HeroSlide[] | null} */ (null));

  useEffect(() => {
    let cancelled = false;

    async function loadSlides() {
      try {
        const body = await apiFetchPublic("/home-hero-photos");
        const photos = body.data?.photos || [];

        if (!cancelled) {
          setSlides(photos.map(photoToSlide));
        }
      } catch {
        if (!cancelled) {
          setSlides([]);
        }
      }
    }

    void loadSlides();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    slides: slides ?? [],
    loading: slides === null,
  };
}
